"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VeelgesteldeVragen() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="w-full bg-dark-background py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 md:grid-cols-2 md:gap-12">
        {}
        <div ref={leftRef} className={`flex flex-col items-center justify-center gap-6 text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${leftVisible ? "translate-y-0 opacity-100" : "translate-y-16 opacity-0"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/inspection_request_illustration.png" alt="Keuring aanvragen illustratie" className="h-48 w-auto object-contain" />
          <h3 className="text-2xl font-semibold text-foreground-dark">
            Klaar om te starten?
          </h3>
          <Link to="/ContactPage">
            <Button size="lg" className="bg-secondary text-foreground-secondary hover:scale-105 hover:shadow-lg transition-all duration-[120ms] ease-in-out">
              Nu aanvragen
            </Button>
          </Link>
        </div>

        {}
        <div ref={rightRef} className={`flex flex-col items-center justify-center gap-6 text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${rightVisible ? "translate-y-0 opacity-100" : "-translate-y-16 opacity-0"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/customer_support_illustration.png" alt="Contact illustratie" className="h-48 w-auto object-contain" />
          <h3 className="text-2xl font-semibold text-foreground-dark">
            Vragen? Neem contact op
          </h3>
          <Link to="/ContactPage">
            <Button size="lg" className="bg-secondary text-foreground-secondary hover:scale-105 hover:shadow-lg transition-all duration-[120ms] ease-in-out">
              Contact
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}